import { defineProductDimensions, mrpwPricingVersionDimension, mrpwSelectedDimension } from '@orus.eu/dimensions'

import { mrpwQuoteDimension, mrpwQuoteV3Dimension } from './mrpw-dimensions.ts'
import { mrpwVersionDimension } from './mrpw-version-dimension.ts'

export * from './mrpw-activity-dimension.ts'
export * from './mrpw-activity-vocabulary.ts'
export * from './mrpw-address-validation-result-dimension.ts'
export * from './mrpw-assistance-dimension.ts'
export * from './mrpw-derogation-assets-value-dimension.ts'
export * from './mrpw-dimensions.ts'
export * from './mrpw-fees-dimension.ts'
export * from './mrpw-guarantee-text.ts'
export * from './mrpw-options-dimension.ts'
export * from './mrpw-product-dimension.ts'
export * from './mrpw-quote-dimension.ts'
export * from './mrpw-subscription-ui.ts'
export * from './mrpw-ui-elements.ts'
export * from './mrpw-version-dimension.ts'
export * from './mrpw-wakam-allowed-city-codes-dimension.ts'
export * from './wakam-util.ts'

export const mrpwDimensionsModule = defineProductDimensions({
  product: 'mrpw',
  family: 'mrp',
  selectionDimension: mrpwSelectedDimension,
  legacyVersionDimension: mrpwVersionDimension, // name 'mrpwVersion' — permanent override (D6), never renamed
  pricingVersionDimension: mrpwPricingVersionDimension,
  quoteV2Dimension: mrpwQuoteDimension,
  quoteV3Dimension: mrpwQuoteV3Dimension,
})
